module.exports = __webpack_public_path__ + "static/media/au-chip.467b255b.png";